const LBS_VALUE = 0.45359237;
const KG_VALUE = 2.2046226218487757;

export const calculateMeanWeight = (biomass: number, qty: number): number => {
  if (biomass && qty) {
    let calc = (biomass * 1000) / qty;
    if (isNaN(calc) || calc == null) return 0;
    return calc;
  }
  return 0;
};

export const calculateHarvestQty = (biomass: number, meanWeight: number, enableKg?: boolean) => {
  if (enableKg) {
    if (biomass && meanWeight) return Math.round((biomass * 1000) / meanWeight);
    return 0;
  }
  if (biomass && meanWeight) return Math.round((biomass * 1000 * LBS_VALUE) / meanWeight);

  return 0;
};

export const calculateBiomass = (meanWeight?: number, quantity?: number, enableKg?: boolean) => {
  if (enableKg !== undefined && !enableKg) {
    if (meanWeight && quantity) return (meanWeight * quantity) / 1000 / LBS_VALUE;
    return 0;
  }
  if (meanWeight && quantity) return (meanWeight * quantity) / 1000;
  return 0;
};

export const kgToLbs = (biomass: number) => biomass / LBS_VALUE;
export const lbsToKg = (biomass: number) => biomass / KG_VALUE;

export const calculateRemainingQty = (remainingBm: number, remainingMw: number, enableKg?: boolean) => {
  if (!remainingBm || !remainingMw) return 0;

  const remainingBmKg = enableKg ? remainingBm : lbsToKg(remainingBm);
  return Math.round((remainingBmKg * 1000) / remainingMw);
};
